// src/admin/data/initialAdminData.js

export const initialDailyCA = [
  {
    id: "dca-2026-10-30",
    title: "Parliamentary Committees and Ex-Officio Chairmanship of the Speaker",
    date: "2026-10-30",
    category: "Polity",
    shortDescription: "An in-depth analysis of the roles of the Business Advisory, Rules, and General Purposes Committees.",
    fullContent: `### Constitutional Context
The Speaker of the Lok Sabha acts as the ex-officio Chairman of three key Parliamentary Committees:
1. **Business Advisory Committee**: Determines the allocation of time for government bills and business.
2. **Rules Committee**: Considers matters of procedure and conduct of business in the House.
3. **General Purposes Committee**: Advises on affairs relating to the House that do not fall under other committees.

### UPSC Relevance (GS Paper II)
Parliamentary committees ensure legislative accountability, bipartisan deliberation, and policy scrutiny away from partisan floor debates. Declining referral of bills to standing committees has emerged as a significant governance debate.`,
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "Parliamentary_Committees_30Oct2026.pdf",
    imageUrl: "https://images.unsplash.com/photo-1541872703-74c5e44368f9?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    author: "Selva Sir",
    views: 1240,
  },
  {
    id: "dca-2026-10-29",
    title: "Quantum Supremacy and India's National Quantum Mission",
    date: "2026-10-29",
    category: "Science & Technology",
    shortDescription: "Technological milestones in quantum computing, qubit coherence, and indigenous hardware development.",
    fullContent: `### What is Quantum Supremacy?
Quantum supremacy refers to a quantum device solving a computational task mathematically or practically impossible for classical supercomputers in reasonable timeframes.

### National Quantum Mission (NQM)
Approved with a budgetary outlay of over ₹6,000 crore, the NQM focuses on developing:
- 50–1000 physical qubits quantum computers within 8 years.
- Satellite-based secure quantum communications over 2000 km.
- High-sensitivity quantum magnetometers and atomic clocks.`,
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "National_Quantum_Mission_29Oct2026.pdf",
    imageUrl: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    author: "Faculty (S&T)",
    views: 980,
  },
  {
    id: "dca-2026-10-28",
    title: "Critical Mineral Alliances and the Mineral Security Partnership (MSP)",
    date: "2026-10-28",
    category: "Environment & Economy",
    shortDescription: "India's accession to the US-led MSP to secure lithium, cobalt, and rare earth supply chains.",
    fullContent: `### Global Strategic Imperative
Critical minerals like lithium, cobalt, nickel, and graphite are the backbone of the clean energy transition, electric vehicles (EVs), and advanced electronics. China currently controls over 60% of worldwide refining capacity.

### India's Position
By joining the Mineral Security Partnership (MSP), India gains strategic co-investment opportunities in Africa, Australia, and South America to power domestic initiatives under the PLI scheme and energy independence targets.`,
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "Critical_Minerals_MSP_28Oct2026.pdf",
    imageUrl: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    author: "Editorial Team",
    views: 1420,
  },
  {
    id: "dca-2026-10-27",
    title: "Fiscal Federalism: Cesses, Surcharges & the Divisible Pool",
    date: "2026-10-27",
    category: "Economy",
    shortDescription: "The debate around Article 271 and State demands for widening the central tax devolution base.",
    fullContent: `### Core Conflict
Under Article 270, the net proceeds of Union taxes are shared with the States on the recommendation of the Finance Commission. However, Article 271 allows the Union to levy cesses and surcharges that do not enter the divisible pool.

### Key Data
Cesses and surcharges have risen from ~9% of gross tax revenue in 2012 to over 18% in recent fiscal years, compressing the effective share received by states despite the headline 41% devolution formula.`,
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "Fiscal_Federalism_27Oct2026.pdf",
    imageUrl: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    author: "Faculty (Economy)",
    views: 1110,
  },
  {
    id: "dca-2026-10-26",
    title: "Maritime Security: Geopolitics of Bab-el-Mandeb & Red Sea Chokepoint",
    date: "2026-10-26",
    category: "International Relations",
    shortDescription: "Disruptions along the Suez-Bab el-Mandeb route and their impact on global freight and Indian exports.",
    fullContent: `### Geographic Importance
Connecting the Red Sea with the Gulf of Aden and Arabian Sea, the Bab-el-Mandeb Strait handles ~12% of global seaborne trade. 

### Economic Impact on India
Diversion around the Cape of Good Hope adds 14–20 days of sailing time and escalates container shipping rates, squeezing margins for Indian agricultural exports, engineering goods, and refined petroleum products.`,
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "Red_Sea_Chokepoints_26Oct2026.pdf",
    imageUrl: "https://images.unsplash.com/photo-1509316975850-ff9c5deb0cd9?auto=format&fit=crop&w=600&q=80",
    status: "Draft",
    author: "Selva Sir",
    views: 0,
  },
];

export const initialMonthlyCA = [
  {
    id: "mca-2026-10",
    month: "October",
    year: "2026",
    title: "Jnana Deepam Monthly Current Affairs Compendium – October 2026",
    description: "Complete compilation covering National Governance, Bilateral Treaties, Macroeconomy, Supreme Court Rulings, and COP Climate Initiatives.",
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "JnanaDeepam_Monthly_Oct2026.pdf",
    pdfSize: "8.4 MB",
    thumbnailUrl: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    downloads: 3420,
    uploadDate: "2026-10-31",
  },
  {
    id: "mca-2026-09",
    month: "September",
    year: "2026",
    title: "Jnana Deepam Monthly Current Affairs Compendium – September 2026",
    description: "Comprehensive coverage of G20 outcomes, SCO Summit resolutions, Biodiversity treaties, and monetary policy trajectory.",
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "JnanaDeepam_Monthly_Sep2026.pdf",
    pdfSize: "7.9 MB",
    thumbnailUrl: "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    downloads: 4890,
    uploadDate: "2026-09-30",
  },
  {
    id: "mca-2026-08",
    month: "August",
    year: "2026",
    title: "Jnana Deepam Monthly Current Affairs Compendium – August 2026",
    description: "Special Independence Month issue covering 75+ years of constitutional democracy, defense indigenization, and space advancements.",
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "JnanaDeepam_Monthly_Aug2026.pdf",
    pdfSize: "9.1 MB",
    thumbnailUrl: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    downloads: 5120,
    uploadDate: "2026-08-31",
  },
  {
    id: "mca-2026-07",
    month: "July",
    year: "2026",
    title: "Jnana Deepam Monthly Current Affairs Compendium – July 2026",
    description: "Union Budget special analysis, Economic Survey insights, agricultural reforms, and environmental jurisprudence.",
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "JnanaDeepam_Monthly_Jul2026.pdf",
    pdfSize: "8.2 MB",
    thumbnailUrl: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?auto=format&fit=crop&w=600&q=80",
    status: "Published",
    downloads: 3990,
    uploadDate: "2026-07-31",
  },
  {
    id: "mca-2026-06",
    month: "June",
    year: "2026",
    title: "Jnana Deepam Monthly Current Affairs Compendium – June 2026",
    description: "Monsoon trends, Indian Ocean Dipole, World Environment Day commitments, and renewable energy storage milestones.",
    pdfUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    pdfName: "JnanaDeepam_Monthly_Jun2026.pdf",
    pdfSize: "7.6 MB",
    thumbnailUrl: "https://images.unsplash.com/photo-1491841573634-28140fc7ced7?auto=format&fit=crop&w=600&q=80",
    status: "Draft",
    downloads: 0,
    uploadDate: "2026-06-30",
  },
];

export const initialPrelimsTests = [
  {
    id: "pt-2026-10-30",
    testName: "Daily Current Affairs Quiz – 30 October 2026",
    category: "Current Affairs",
    date: "2026-10-30",
    duration: 16, // minutes
    totalQuestions: 10,
    totalMarks: 20,
    marksPerCorrect: 2.0,
    negativeMarks: 0.66,
    totalParticipants: 412,
    averageScore: 12.8,
    status: "Published",
    pdfStudyMaterial: "Daily_Quiz_30Oct_Notes.pdf",
    questions: [
      {
        qId: 1,
        topic: "Polity & Parliamentary Committees",
        question: "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        options: ["1, 2 and 3 only", "1, 3 and 4 only", "2, 3 and 4 only", "1, 2, 3 and 4"],
        correctAnswer: 1,
        explanation: "The Speaker of Lok Sabha is ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        qId: 2,
        topic: "Science & Technology",
        question: "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        options: [
          "A state where quantum computers completely replace classical binary servers.",
          "The ability of a quantum device to solve a problem impossible for classical computers in reasonable time.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "Military superiority gained through quantum satellite links."
        ],
        correctAnswer: 1,
        explanation: "Quantum supremacy refers to a programmable quantum device demonstrating capability beyond any classical computer."
      },
      {
        qId: 3,
        topic: "Environment - Critical Minerals",
        question: "Which international alliance has India joined to secure global supply chains for critical energy transition minerals?",
        options: [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel"
        ],
        correctAnswer: 0,
        explanation: "India joined the US-led Mineral Security Partnership (MSP) in 2023 as the 14th member nation."
      }
    ]
  },
  {
    id: "pt-2026-10-29",
    testName: "Daily Current Affairs Quiz – 29 October 2026",
    category: "Current Affairs",
    date: "2026-10-29",
    duration: 16,
    totalQuestions: 10,
    totalMarks: 20,
    marksPerCorrect: 2.0,
    negativeMarks: 0.66,
    totalParticipants: 389,
    averageScore: 11.4,
    status: "Published",
    pdfStudyMaterial: "Daily_Quiz_29Oct_Notes.pdf",
    questions: [
      {
        qId: 1,
        topic: "Voting Rights & Supreme Court Precedents",
        question: "With reference to Voting Rights in India, consider the following statements:\n1. The right to vote is a statutory right under RPA 1951.\n2. In Kuldip Nayar (2006), SC affirmed it is not a Fundamental Right.\nWhich of the statements given above is/are correct?",
        options: ["1 only", "2 only", "Both 1 and 2", "Neither 1 nor 2"],
        correctAnswer: 2,
        explanation: "Both statements are correct under Indian constitutional jurisprudence."
      }
    ]
  },
  {
    id: "pt-2026-gs1-mock",
    testName: "UPSC Prelims 2027 Full Length GS Mock Test - 01",
    category: "Full Mock Test",
    date: "2026-10-25",
    duration: 120,
    totalQuestions: 100,
    totalMarks: 200,
    marksPerCorrect: 2.0,
    negativeMarks: 0.66,
    totalParticipants: 1250,
    averageScore: 94.2,
    status: "Published",
    pdfStudyMaterial: "GS_Full_Mock_Test_01_Key.pdf",
    questions: []
  },
  {
    id: "pt-2026-polity-sectional",
    testName: "Sectional Test: Indian Polity & Constitutional Framework",
    category: "Sectional Test",
    date: "2026-10-20",
    duration: 60,
    totalQuestions: 50,
    totalMarks: 100,
    marksPerCorrect: 2.0,
    negativeMarks: 0.66,
    totalParticipants: 840,
    averageScore: 61.5,
    status: "Published",
    pdfStudyMaterial: "Polity_Sectional_Solutions.pdf",
    questions: []
  }
];

export const initialMainsInitiatives = [
  {
    id: "mains-2026-10-31-q1",
    title: "Ocean-Atmospheric Teleconnections and Sudden Coastal Inundation",
    paper: "GS Paper 1",
    subject: "Physical Geography",
    topic: "Important Geophysical Phenomena, Oceanic Hazards, and Kallakkadal Events",
    question: "Explain the phenomenon of 'Kallakkadal' observed along the south-western coast of India. How does it differ from a tsunami, and what early warning mechanisms are in place to mitigate coastal vulnerability? (150 words, 10 marks)",
    instructions: "Structure the answer into: Definition & Etymology, Mechanism of generation (Southern Ocean swells), Comparison with Tsunami, and Early Warning (INCOIS Swell Surge System).",
    maxMarks: 10,
    wordLimit: 150,
    deadline: "2026-11-05",
    submissionsCount: 48,
    status: "Published",
    modelAnswerPdf: "Model_Answer_Kallakkadal_GS1.pdf"
  },
  {
    id: "mains-2026-10-31-q2",
    title: "Federal Fiscal Balance and Devolution Dynamics",
    paper: "GS Paper 2",
    subject: "Indian Polity & Governance",
    topic: "Functions and Responsibilities of Union and States, Issues and Challenges Pertaining to the Federal Structure",
    question: "The increasing reliance on cesses and surcharges by the Union Government poses a structural challenge to cooperative fiscal federalism. Critically analyze in light of the recommendations of recent Finance Commissions. (250 words, 15 marks)",
    instructions: "Discuss Article 270 vs Article 271, trends in cess collection as % of Gross Tax Revenue, impact on State capital expenditures, and potential reforms like capping cesses.",
    maxMarks: 15,
    wordLimit: 250,
    deadline: "2026-11-06",
    submissionsCount: 62,
    status: "Published",
    modelAnswerPdf: "Model_Answer_Fiscal_Federalism_GS2.pdf"
  },
  {
    id: "mains-2026-10-28-q1",
    title: "Critical Minerals and India's Strategic Clean Energy Transition",
    paper: "GS Paper 3",
    subject: "Economic Development & Environment",
    topic: "Infrastructure: Energy, Ports, Roads, and Supply Chain Security",
    question: "Securing resilient domestic and international supply chains for critical minerals is vital for India's Panchamrit climate goals. Evaluate the challenges and strategic policy responses undertaken so far. (250 words, 15 marks)",
    instructions: "Highlight key critical minerals (Lithium, Nickel, Rare Earths), geopolitical bottlenecks (refining monopoly), domestic exploration (J&K lithium), and international pacts (MSP, KABIL).",
    maxMarks: 15,
    wordLimit: 250,
    deadline: "2026-11-04",
    submissionsCount: 54,
    status: "Published",
    modelAnswerPdf: "Model_Answer_Critical_Minerals_GS3.pdf"
  },
  {
    id: "mains-2026-10-25-q1",
    title: "Ethical Dimensions of Artificial Intelligence in Governance",
    paper: "GS Paper 4",
    subject: "Ethics, Integrity & Aptitude",
    topic: "Ethics in Public Administration, Transparency and Accountability in Technology Adoption",
    question: "As algorithmic decision-making expands into welfare distribution and predictive policing, what ethical safeguards are imperative to ensure justice, non-discrimination, and public accountability? (150 words, 10 marks)",
    instructions: "Focus on algorithmic bias, right to explanation, human-in-the-loop oversight, data privacy as a dignity concern, and bureaucratic empathy.",
    maxMarks: 10,
    wordLimit: 150,
    deadline: "2026-11-03",
    submissionsCount: 71,
    status: "Published",
    modelAnswerPdf: "Model_Answer_Ethics_AI_GS4.pdf"
  }
];

export const initialStudentResults = [
  {
    id: "res-001",
    studentName: "Lavanya Rengaraj",
    regId: "SIA-2026-0891",
    email: "lavanyarengaraj739@gmail.com",
    phone: "9345283928",
    examType: "Prelims",
    initiativeName: "Daily Current Affairs Quiz – 30 October 2026",
    testId: "pt-2026-10-30",
    totalQuestions: 10,
    correctAnswers: 8,
    incorrectAnswers: 2,
    unanswered: 0,
    marksObtained: 14.68,
    totalMarks: 20.0,
    percentage: 73.4,
    rank: 4,
    status: "Completed",
    submissionDate: "2026-10-30 18:24",
    timeSpentMinutes: 14,
    details: [
      { qNum: 1, topic: "Polity", isCorrect: true, userPick: "1, 3 and 4 only", correctPick: "1, 3 and 4 only" },
      { qNum: 2, topic: "Science & Tech", isCorrect: true, userPick: "The ability of a quantum device...", correctPick: "The ability of a quantum device..." },
      { qNum: 3, topic: "Environment", isCorrect: true, userPick: "Mineral Security Partnership (MSP)", correctPick: "Mineral Security Partnership (MSP)" },
      { qNum: 4, topic: "Economy", isCorrect: false, userPick: "Corporation Tax", correctPick: "Cesses and Surcharges levied under Article 271" },
      { qNum: 5, topic: "Geography", isCorrect: true, userPick: "Red Sea and Gulf of Aden", correctPick: "Red Sea and Gulf of Aden" },
      { qNum: 6, topic: "Energy", isCorrect: true, userPick: "At least 5 MMT per annum", correctPick: "At least 5 MMT per annum" },
      { qNum: 7, topic: "Environment", isCorrect: true, userPick: "Both 1 and 2", correctPick: "Both 1 and 2" },
      { qNum: 8, topic: "Trade", isCorrect: true, userPick: "European Union", correctPick: "European Union" },
      { qNum: 9, topic: "Economy", isCorrect: false, userPick: "Public Sector Telecom Companies", correctPick: "Systemically Significant Digital Enterprises" },
      { qNum: 10, topic: "Space Tech", isCorrect: true, userPick: "Both 1 and 2", correctPick: "Both 1 and 2" },
    ]
  },
  {
    id: "res-002",
    studentName: "Aravind Kumar",
    regId: "SIA-2026-0412",
    email: "aravind.k@gmail.com",
    phone: "9840123456",
    examType: "Prelims",
    initiativeName: "Daily Current Affairs Quiz – 30 October 2026",
    testId: "pt-2026-10-30",
    totalQuestions: 10,
    correctAnswers: 9,
    incorrectAnswers: 1,
    unanswered: 0,
    marksObtained: 17.34,
    totalMarks: 20.0,
    percentage: 86.7,
    rank: 1,
    status: "Completed",
    submissionDate: "2026-10-30 19:10",
    timeSpentMinutes: 12,
  },
  {
    id: "res-003",
    studentName: "Sneha Patel",
    regId: "SIA-2026-0745",
    email: "sneha.patel@gmail.com",
    phone: "9789123456",
    examType: "Mains",
    initiativeName: "Ocean-Atmospheric Teleconnections and Sudden Coastal Inundation",
    questionId: "mains-2026-10-31-q1",
    gsPaper: "GS Paper 1",
    wordCount: 148,
    marksObtained: 7.5,
    totalMarks: 10.0,
    percentage: 75.0,
    rank: 2,
    status: "Evaluated",
    submissionDate: "2026-10-31 10:15",
    studentAnswerText: `Kallakkadal refers to sudden coastal flooding without any local meteorological precursors, typically observed along the southwestern coastline of India, especially Kerala and Lakshadweep. The term was formally recognized by UNESCO in 2012 and translates from Malayalam as 'sea that arrives like a thief'.

Difference from Tsunami:
1. Origin: Tsunamis are seismic or volcanic in origin (undersea earthquakes/landslides), whereas Kallakkadal is purely meteorological, driven by distant ocean storms in the Southern Ocean (30°S to 50°S).
2. Wave Period: Kallakkadal swell waves possess long periods (15–22 seconds) and travel thousands of nautical miles across the Indian Ocean without losing energy.
3. Local Atmosphere: Unlike storm surges triggered by cyclones, Kallakkadal occurs in completely calm, clear local weather.

Mitigation & Early Warning:
INCOIS operationalized the Swell Surge Warning System, providing coastal alerts 2–3 days in advance. Integrated coastal zone management and natural bio-shields (mangroves) are vital for long-term resilience.`,
    evaluatorMarks: 7.5,
    evaluatorFeedback: "Impressive conceptual clarity. Good demarcation between Tsunami and swell surge. Mentions INCOIS Swell Surge Warning System and UNESCO recognition. Introduction is sharp.",
    evaluationDate: "2026-10-31 16:30",
    evaluatorName: "Dr. Selva",
  },
  {
    id: "res-004",
    studentName: "Karthik Subramanian",
    regId: "SIA-2026-0158",
    email: "karthik.sub@gmail.com",
    phone: "9444123456",
    examType: "Mains",
    initiativeName: "Federal Fiscal Balance and Devolution Dynamics",
    questionId: "mains-2026-10-31-q2",
    gsPaper: "GS Paper 2",
    wordCount: 242,
    marksObtained: 10.5,
    totalMarks: 15.0,
    percentage: 70.0,
    rank: 5,
    status: "Evaluated",
    submissionDate: "2026-10-31 14:40",
    studentAnswerText: `Fiscal federalism in India is rooted in Constitutional equity and developmental balance. While Article 270 provides for a divisible tax pool recommended by the Finance Commission (currently 41%), Article 271 grants the Centre power to levy cesses and surcharges exclusively for Union purposes.

Key Challenges Arising from Cesses:
1. Erosion of Divisible Pool: Cesses have grown from ~9% in 2012 to over 18% of Gross Tax Revenue, resulting in states effectively getting only 31-33% rather than 41%.
2. Unspent Reserves: CAG reports highlight that proceeds from road cess, education cess, and health cess frequently remain uncredited to designated reserve funds.
3. Asymmetric Expenditure Burdens: States execute over 60% of public developmental and social sector capital expenditure while collecting less than 38% of revenue.

Way Forward:
1. Constitutional amendment capping cesses at 10% of gross central taxes.
2. Progressive absorption of perennial cesses into standard GST and Corporate Tax slabs.
3. Strengthening the Inter-State Council as an active consensus forum for fiscal governance.`,
    evaluatorMarks: 10.5,
    evaluatorFeedback: "Well-structured response with accurate Constitutional provisions (Art 270 vs 271). Concrete data points regarding effective devolution vs headline rate. Suggestions are pragmatic.",
    evaluationDate: "2026-11-01 11:20",
    evaluatorName: "Prof. S. Rengaraj",
  },
  {
    id: "res-005",
    studentName: "Ananya Sharma",
    regId: "SIA-2026-0923",
    email: "ananya.ias@gmail.com",
    phone: "9811123456",
    examType: "Mains",
    initiativeName: "Critical Minerals and India's Strategic Clean Energy Transition",
    questionId: "mains-2026-10-28-q1",
    gsPaper: "GS Paper 3",
    wordCount: 238,
    marksObtained: null,
    totalMarks: 15.0,
    percentage: null,
    rank: null,
    status: "Pending Evaluation",
    submissionDate: "2026-11-01 19:20",
    studentAnswerText: `Critical minerals such as lithium, cobalt, nickel, and rare earth elements (REEs) form the building blocks for electric vehicles, renewable batteries, and semiconductor electronics. For India to realize its net-zero 2070 and 500 GW non-fossil goals, securing these elements is non-negotiable.

Strategic Challenges:
1. Geographic Concentration: Over 70% of lithium refining is controlled by China, creating single-supplier vulnerability.
2. Extraction Ecological Footprint: High water intensity and local ecological resistance in mining belts.
3. Technology Gaps: Lack of advanced domestic smelting and hydrometallurgical processing capabilities.

Government Initiatives:
1. KABIL (Khanij Bidesh India Ltd): Joint venture acquiring lithium brine blocks in Argentina.
2. Mineral Security Partnership: Accession to western critical mineral clubs to de-risk supply.
3. Domestic Auctions: GSI auctions in Jammu & Kashmir (Reasi) and Chhattisgarh.`,
    evaluatorMarks: null,
    evaluatorFeedback: null,
    evaluationDate: null,
    evaluatorName: null,
  },
  {
    id: "res-006",
    studentName: "Rajesh Varman",
    regId: "SIA-2026-0331",
    email: "rajesh.v@gmail.com",
    phone: "9445123456",
    examType: "Prelims",
    initiativeName: "UPSC Prelims 2027 Full Length GS Mock Test - 01",
    testId: "pt-2026-gs1-mock",
    totalQuestions: 100,
    correctAnswers: 58,
    incorrectAnswers: 24,
    unanswered: 18,
    marksObtained: 100.16,
    totalMarks: 200.0,
    percentage: 50.08,
    rank: 18,
    status: "Completed",
    submissionDate: "2026-10-26 14:00",
    timeSpentMinutes: 110,
  },
  {
    id: "res-007",
    studentName: "Divya Meenakshi",
    regId: "SIA-2026-0619",
    email: "divya.m@gmail.com",
    phone: "9884123456",
    examType: "Prelims",
    initiativeName: "Sectional Test: Indian Polity & Constitutional Framework",
    testId: "pt-2026-polity-sectional",
    totalQuestions: 50,
    correctAnswers: 38,
    incorrectAnswers: 8,
    unanswered: 4,
    marksObtained: 70.72,
    totalMarks: 100.0,
    percentage: 70.72,
    rank: 3,
    status: "Completed",
    submissionDate: "2026-10-21 17:30",
    timeSpentMinutes: 52,
  }
];

export const initialActivities = [
  {
    id: "act-1",
    title: "Published Daily Current Affairs",
    description: "Parliamentary Committees and Ex-Officio Chairmanship (30 Oct 2026)",
    timestamp: "2 hours ago",
    type: "upload",
    category: "Daily CA",
    user: "Admin (Selva Sir)",
  },
  {
    id: "act-2",
    title: "Mains Answer Evaluated",
    description: "Evaluated Karthik Subramanian's response on Fiscal Federalism (10.5/15)",
    timestamp: "4 hours ago",
    type: "evaluation",
    category: "Mains",
    user: "Prof. S. Rengaraj",
  },
  {
    id: "act-3",
    title: "Student Submission Received",
    description: "Ananya Sharma submitted answer for Critical Minerals & Clean Energy Transition",
    timestamp: "Yesterday",
    type: "submission",
    category: "Mains",
    user: "System",
  },
  {
    id: "act-4",
    title: "Published Monthly Compendium",
    description: "Jnana Deepam Monthly Current Affairs Compendium – October 2026 (PDF, 8.4 MB)",
    timestamp: "2 days ago",
    type: "upload",
    category: "Monthly CA",
    user: "Editorial Team",
  },
  {
    id: "act-5",
    title: "Prelims Test Conducted",
    description: "Daily Current Affairs Quiz – 30 October 2026 (412 students attempted)",
    timestamp: "2 days ago",
    type: "test",
    category: "Prelims",
    user: "System",
  },
];

export const initialSettings = {
  academyName: "Selva's IAS Academy",
  tagline: "Discover Path to UPSC | IAS, IPS, IFS...",
  contactEmail: "admin@gmail.com",
  adminPhone: "+91 8012003040",
  address: "Anna Nagar, Chennai, Tamil Nadu, India",
  autoPublishResults: true,
  emailNotifications: true,
  maintenanceMode: false,
};
